import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Space,
} from "antd";
import { DOCK_TYPES } from "../../../common/constants";
import apiPaths from "../../../api/paths";
import { apiRequest } from "../../../api";
import { useEffect, useState } from "react";

function VehicleRouteModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  isUpdate = false,
  vehicles = [],
  routeType,
}) {
  const [form] = Form.useForm();
  const type = Form.useWatch("route_type", form);
  const [stations, setStations] = useState([]);

  const fetchStations = async () => {
    const res = await apiRequest({
      path: apiPaths.stations + `?station_type=Barc`,
    });
    if (res.error) {
      message.error("Error in getting stations");
      return;
    }
    setStations(res.results);
  };

  useEffect(() => {
    if (routeType == "Barc" && !stations.length) {
      fetchStations();
    }
  }, [type]);

  return (
    <Modal
      title={isUpdate ? "Update Vehicle Route" : "Add Vehicle Route"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={(values) => {
          values.route_type = values.route_type.value;
          values.id_vehicle = values.vehicle.value;
          values.status = values.status.value;
          if (routeType == "Barc") {
            if (values.id_start_dock.value == values.id_end_dock.value) {
              message.error("Start and End station should not be same");
              return;
            }
            values.id_start_dock = values.id_start_dock.value;
            values.id_end_dock = values.id_end_dock.value;
          }
          delete values.vehicle;
          onSave(values);
        }}
        initialValues={
          Object.keys(data).length
            ? {
                ...data,
                vehicle: {
                  label: data.vehicle.name,
                  value: data.vehicle.id,
                },
                status: { label: data.status, value: data.status },
                route_type: { label: routeType, value: routeType },
                ...(routeType == "Barc"
                  ? {
                      id_start_dock: {
                        label: data.start_dock.name,
                        value: data.start_dock.id,
                      },
                      id_end_dock: {
                        label: data.end_dock.name,
                        value: data.end_dock.id,
                      },
                    }
                  : {}),
              }
            : {
                status: { label: "active", value: "active" },
                route_type: { label: routeType, value: routeType },
              }
        }
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Vehicle"
              name={"vehicle"}
              rules={[
                {
                  required: true,
                  message: `Please select vehicle!`,
                },
              ]}
            >
              <Select
                placeholder={"Select vehicle"}
                showSearch
                style={{ width: 280 }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                labelInValue={true}
              >
                {vehicles.map((item, index) => (
                  <Select.Option key={index + "o"} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Route Type"
              name={"route_type"}
              rules={[
                {
                  required: true,
                  message: "Please select Route Type",
                },
              ]}
            >
              <Select
                disabled={true}
                labelInValue={true}
                options={Object.values(DOCK_TYPES)}
                placeholder="Select Route Type"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          {type?.value == "Barc" ? (
            <>
              <Col span={12}>
                <Form.Item
                  label="From Station"
                  name="id_start_dock"
                  rules={[
                    {
                      required: true,
                      message: "Please selct From Station",
                    },
                  ]}
                >
                  <Select
                    placeholder={"Select station"}
                    showSearch
                    style={{ width: 280 }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    labelInValue={true}
                  >
                    {stations.map((item, index) => (
                      <Select.Option key={index + "o"} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="To Station"
                  name="id_end_dock"
                  rules={[
                    {
                      required: true,
                      message: "Please select To Station",
                    },
                  ]}
                >
                  <Select
                    placeholder={"Select station"}
                    showSearch
                    style={{ width: 280 }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    labelInValue={true}
                  >
                    {stations.map((item, index) => (
                      <Select.Option key={index + "o"} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </>
          ) : (
            <Col span={12}>
              <Form.Item
                label="From and To"
                name="from_and_to"
                rules={[
                  {
                    required: true,
                    message: "Please add From and To",
                  },
                ]}
              >
                <Input placeholder="from and to" />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Charges"
              name="charges"
              rules={[
                {
                  required: true,
                  message: "Please Charges",
                },
              ]}
            >
              <InputNumber style={{ width: 200 }} placeholder="Charges" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Status"
              name={"status"}
              rules={[
                {
                  required: true,
                  message: "Please select Status",
                },
              ]}
            >
              <Select
                labelInValue={true}
                options={[
                  { text: "Active", value: "active" },
                  { text: "Inactive", value: "inactive" },
                ]}
                placeholder="Select Status"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {isUpdate ? "Save" : "Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default VehicleRouteModal;
